// Launch Fast on page opening
document.addEventListener('turbo:load', async () => {
  if (window.location.hash.includes('#open-fast') || window.location.pathname === '/fonctionnement-codeur') {
    if (document.querySelector('meta[name="fast"]')?.content === 'mini') {
      const { openMiniFast } = await import('@/utils/mini_fast.js')
      window.location.hash = ''
      await openMiniFast('/projects/new', window.location.search)
    } else {
      const { fastApp } = await import('@/apps/fast/main.js')
      await fastApp
      window.location.hash = ''
      window.FastApp.launch(window.location.search)
    }
    $('.hiw-tmp-overlay').fadeOut()
  }
})
